// extracted by mini-css-extract-plugin
export default {"subtitle":"CategorySubtitle_subtitle__cAyRr"};